export default "__VITE_ASSET__MYrck6pH__"